export default __webpack_public_path__ + "map-marker.f379f3337663eb5ee76d.png";